/* eslint-disable compat/compat */

export function createSharedWorker({
  url,
  name
}) {
  const result = {
    worker: null,
    error: null
  };
  try {
    result.worker = new SharedWorker(url, {
      name,
      credentials: 'include'
    });
  } catch (e) {
    result.error = e;
  }
  return result;
}